export default __webpack_public_path__ + "media/zurb/img/services/tools/foundation-screenshot1-8d7f2aaa8d41e07d4319093dad012b66.png";